import FormPriceActivity from "./FormPriceActivity";
import FormPriceHotel from "./FormPriceHotel";
import FormPriceTransfer from "./FormPriceTransfer";
import FormPricePackage from "./FormPricePackage";
import FormPriceFlight from "./FormPriceFlight";
const FormPrice = (props) => {
  const composite = {
    activity: <FormPriceActivity {...props} />,
    transfer: <FormPriceTransfer {...props} />,
    hotel: <FormPriceHotel {...props} />,
    package: <FormPricePackage {...props} />,
    flight: <FormPriceFlight {...props} />,
  };

  if (!composite[props.service]) {
    return <>EN COURS</>;
  }

  return <>{composite[props.service]}</>;
};

export default FormPrice;
